// src/utils/azioniNF.js
// Azioni dell'ufficio Acquisti su una NF (W435), le stesse da Centro Acquisti e dal dettaglio:
// prendere in gestione, trasformare la descrizione in articoli, annullare con un motivo.
// Chi ha fatto la richiesta riceve sempre la notifica in app.
import { addDoc, collection, doc, serverTimestamp, updateDoc } from "firebase/firestore";
import { db } from "../firebase";
import { articoliValidi } from "./acquisti";

const avvisaAutore = async (nf, orgId, utente, titolo, testo) => {
  if (!nf.createdBy || nf.createdBy === utente?.uid) return;
  try {
    await addDoc(collection(db, "notifiche"), { userId: nf.createdBy, orgId, tipo: "nf_presa_in_carico", titolo, testo, letta: false, createdAt: serverTimestamp() });
  } catch { /* la notifica non blocca l'azione */ }
};
const primaRiga = (nf) => String(nf.descrizione || "").split("\n")[0].slice(0, 80);

/** Campi della presa in gestione (vuoto se è già in gestione). */
export function campiPresaInGestione(nf, utente) {
  if (nf.presaInCaricoDa) return {};
  return { presaInCaricoDa: utente?.uid || "", presaInCaricoDaNome: utente?.displayName || "", presaInCaricoAt: serverTimestamp() };
}

export async function prendiInGestione(nf, utente, orgId) {
  if (nf.presaInCaricoDa) return;
  await updateDoc(doc(db, "nuoveForniture", nf.id), { ...campiPresaInGestione(nf, utente), updatedAt: serverTimestamp() });
  await avvisaAutore(nf, orgId, utente, "La tua NF è in gestione",
    `${utente?.displayName || "L'ufficio Acquisti"} ha preso in gestione la NF #${nf.numero || ""}: "${primaRiga(nf)}"`);
}

/** Articoli ricavati dalla descrizione, confermati dall'ufficio Acquisti (la descrizione resta com'era). */
export async function salvaArticoliNf(nf, articoli, utente, orgId) {
  const presa = campiPresaInGestione(nf, utente);
  await updateDoc(doc(db, "nuoveForniture", nf.id), {
    articoli: articoliValidi(articoli), articoliDaDescrizioneDa: utente?.displayName || "", articoliDaDescrizioneAt: serverTimestamp(),
    ...presa, updatedAt: serverTimestamp(),
  });
  if (presa.presaInCaricoDa) await avvisaAutore(nf, orgId, utente, "La tua NF è in gestione",
    `${utente?.displayName || "L'ufficio Acquisti"} ha preso in gestione la NF #${nf.numero || ""} e ha messo in ordine gli articoli`);
}

export async function annullaNf(nf, motivo, utente, orgId) {
  await updateDoc(doc(db, "nuoveForniture", nf.id), {
    annullata: true, motivoAnnullamento: String(motivo || "").trim(), annullataDa: utente?.uid || "", annullataDaNome: utente?.displayName || "",
    annullataAt: serverTimestamp(), updatedAt: serverTimestamp(),
  });
  await avvisaAutore(nf, orgId, utente, "La tua NF è stata annullata",
    `${utente?.displayName || "L'ufficio Acquisti"} ha annullato la NF #${nf.numero || ""}: ${String(motivo || "").trim()}`);
}
